/*
 * @Author: zhangxl 
 * @Date: 2019-05-17 14:14:22 
 * @Last Modified by: Huang Haocheng
 * @Last Modified time: 2019-09-19 16:21:38
 * 用户中心接口
 */
import axios from 'axios'

// 区域部分

/**
 * 查询区域
 * @param {Object} params 参数对象
 */
const getAreaPage_API = params => {
    return axios.post('http://192.168.1.254:8099/api/System/GetAreaPage', params)
}

/**
 * 添加区域
 * @param {Object} params 参数对象
 */
const addArea_API = params => {
    return axios.post('/api/System/AddArea', params)
}

/**
 * 查区域
 * @param {Object} params 参数对象
 */
const getAreaById_API = params => {
    return axios.get('/api/System/GetAreaById', {
        params: params
    })
}

/**
 * 改区域
 * @param {Object} params 参数对象
 */
const updateArea_API = params => {
    return axios.post('/api/System/UpdateArea', params)
}

// 设备部分

/**
 * 查询设备
 * @param {Object} params 参数对象
 */
const getEquipments_API = params => {
    return axios.get('http://iaapi.obj1.cn/api/Statistics/QueryVideo?entCode=SGZ', )
}

/**
 * 添加设备
 * @param {Object} params 参数对象
 */
const addEquipment_API = params => {
    return axios.post('/api/System/AddEquipment', params)
}

/**
 * 查设备
 * @param {Object} params 参数对象
 */
const getEquipmentById_API = params => {
    return axios.get('/api/System/GetEquipmentById', {
        params: params
    })
}

/**
 * 改设备
 * @param {Object} params 参数对象
 */
const updateEquipment_API = params => {
    return axios.post('/api/System/UpdateEquipment', params)
}

export {
    getAreaPage_API,
    addArea_API,
    getAreaById_API,
    updateArea_API,
    getEquipments_API,
    addEquipment_API,
    getEquipmentById_API,
    updateEquipment_API
}